import { Component } from 'vue-property-decorator'
import { Getter, State, Mutation, Action } from 'vuex-class'
import BasePage from '@/views/BasePage/BasePage'
import { VueTelInput } from 'vue-tel-input'
import { configService } from '@/settings/api-url'
import Loading from '@/components/loading/loading'
import Alert from '@/components/alert/alert'

@Component({
  components: {
    VueTelInput,
    Loading,
    Alert
  }
})
export default class LoginCellphone extends BasePage {
  @Action action_getLoginCodeCell;
  @Action action_getLoginCellSearch;
  @Action action_getCreateCodeCell;
  @Action action_getLoginCodeCellWhatsapp;
  @Action action_getCreateCodeCellWhatsapp;

  loading = false;
  loadingWhatsapp = false;
  valid = false;
  msgError = null;
  cellphone = "";
  cellphoneCode = "";
  configInputTel = {
    defaultCountry: "co",
    onlyCountries: [
      "co",
      "mx",
      "pe",
      "ar",
      "bs",
      "bb",
      "bz",
      "bo",
      "br",
      "ca",
      "cl",
      "cr",
      "cu",
      "dm",
      "ec",
      "sv",
      "us",
      "gt",
      "gy",
      "ht",
      "jm",
      "ni",
      "pa",
      "py",
      "do",
      "kn",
      "vc",
      "lc",
      "sr",
      "tt",
      "uy",
      "ve"
    ],
    validCharactersOnly: true
  };

  /* Alert Modal */
  showAlert = false;
  showAlertUserExist = false;

  /* Alert Modal */
  _signup() {
    this.$router.push({ name: "loginCellphone", params: { type: "crear" } });
    this._close();
  }

  _login() {
    this.$router.push({ name: "loginCellphone", params: { type: "sms" } });
    this._close();
  }

  _tryOtherNumber() {
    this._close();
  }

  _close() {
    this.showAlert = false;
    this.showAlertUserExist = false;
  }
  get getTitlte() {
    switch (this.$route.params.type) {
      case "sms":
        return "Teléfono 🤳🏼";
      case "crear":
        return "Crea tu cuenta";
      case "buscar":
        return "Buscar cuenta 🔍";
      default:
        return "";
    }
  }

  get getText() {
    switch (this.$route.params.type) {
      case "buscar":
        return "No encontramos una cuenta con ese correo, escribe tu celular para buscar tu cuenta.";
      case "crear":
        return "Crea tu cuenta utilizando tu número de celular.";
      default:
        return "";
    }
  }

  get getValid() {
    if (this.loading) return true;
    else return !this.valid;
  }

  get getValidWhatsapp() {
    if (this.loading) return true;
    else return !this.valid;
  }

  async _send() {
    this.loading = true;
    const cell = `${this.cellphoneCode}${this.cellphone}`;

    try {
      switch (this.$route.params.type) {
        case "buscar": // Mail no encontrado, buscar por cell
          const res = await this.action_getLoginCellSearch(cell); // users/check_email_by_phone?cellphone=12345
          const email = res.data.email;
          const code = res.data.temporary_code;
          this.$router.push({ name: "loginAccount", params: { cell, email, code } });
          break;

        case "sms": // Ingresa con tu teléfono
          await this.action_getLoginCodeCell(cell); // users/get_sms_code?cellphone=123456
          this.$router.push({ name: "loginCellCode", params: { type: cell } });
          break;

        case "crear": // Crear cuenta
          try {
            const resx = await this.action_getLoginCellSearch(cell); // users/get_sms_code?cellphone=$123
            if (resx.status == 201) {
              this.showAlertUserExist = true;
            }
          } catch (e) {
            await this.action_getCreateCodeCell(cell); // users/get_sms_code?cellphone=$123&is_new_user=true
            this.$router.push({
              name: "createCellCode",
              params: {
                type: cell,
                createAccount: "true",
                whatsapp: "false"
              }
            });
          }
          break;
      }
    } catch (e) {
      this.showAlert = true;
    }
    this.loading = false;
  }

  async _sendWhatsapp() {
    this.loadingWhatsapp = true;
    const cell = `${this.cellphoneCode}${this.cellphone}`;

    if (this.$route.params.type === "crear") {
      await this.action_getCreateCodeCellWhatsapp(cell); // users/get_sms_code?cellphone=$123&is_new_user=true
      this.$router.push({
        name: "createCellCode",
        params: {
          type: cell,
          createAccount: "true",
          whatsapp: "false"
        }
      });
    } else {
      try {
        const res = await this.action_getLoginCodeCellWhatsapp(cell); // users/get_wa_link?cellphone=123
        this.$router.push({ name: "loginCellCode", params: { type: cell, whatsapp: "true" } });
      } catch (e) {
        this.showAlert = true;
      }
      this.loadingWhatsapp = false;
    }
  }

  async _CellPhoneFind2() {
    try {
      this.loading = true;
      const cell = `${this.cellphoneCode}${this.cellphone}`;

      if (this.$route.params.type === "buscar") {
        const res = await this.action_getLoginCellSearch(cell);
        const email = res.data.email;
        const code = res.data.temporary_code;
        this.$router.push({ name: "loginAccount", params: { cell, email, code } });
      } else {
        await this.action_getLoginCodeCell(cell);

        this.$router.push({ name: "loginCellCode", params: { type: cell } });
      }
      this.loading = false;
    } catch (error) {
      this.showAlert = true;
      this.loading = false;
    }
  }

  _selectCellphone(number, isValid) {
    const valid = isValid.valid;
    this.valid = valid;
    if (valid) {
      this.msgError = "";
      this.cellphone = isValid.number.input;
      this.cellphoneCode = isValid.country.dialCode;
    } else {
      this.msgError = "Por favor escribir un número valido";
    }
  }

  _onClose() {
    localStorage.removeItem("_tc");
    // remove the axios default heade
    delete configService.defaults.headers.common["Authorization"];
    this.$router.push({ name: "login" });
  }
}
